
type menuOptions = {
    id: string;
    header: string;
    icon?: string;
    image?: string;
    to?: string;
    link?: string;
    needsSubscription?: boolean;
    hide?: boolean;
    needsSubscriptionFunc?: () => void;
    children?: {
        label: string;
        link?: string;
        to?: string;
        conditional?: boolean;
        action?: () => void;
        needsSubscription?: boolean;
        needsSubscriptionFunc?: () => void;
    }[];
};

import { Component, Inject, Vue, Watch } from "vue-property-decorator";
// @ts-ignore
import ClickOutside from "vue-click-outside";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { Container } from "inversify";
import {
    hasEnterpriseSubscription,
    isAdmin,
    isQuiltySubscribed,
    isSubscribed,
    isThirdpartyAdmin,
} from "@gsx/common";
import { NotificationStore } from "../../../../common/src/stores/NotificationStore";
import { IndividualSubscriptionRedirectModalStore } from "../../../../common/src/subscription-quote/IndividualSubscriptionRedirectModalStore";
import { SubscriptionQuoteModalStore } from "../../../../common/src/subscription-quote/SubscriptionQuoteModalStore";

@Component({
    directives: { ClickOutside },
})
export default class Navigation extends Vue {
    @Inject("container") container!: Container;
    readonly authStore: AuthStore = this.container.get(AuthStore);
    notificationStore: NotificationStore = this.container.get(NotificationStore);
    readonly modalStore: IndividualSubscriptionRedirectModalStore = this.container.get(
        IndividualSubscriptionRedirectModalStore,
    );
    readonly subscriptionQuoteModalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );

    isSidebarOpen = true;

    @Watch("$route.path")
    onRouteChange(newRoutePath: string) {
        if (newRoutePath.includes("/organizations/")) {
            this.ensureSidebarIsOpen();
        }
    }

    readonly accountMenu: menuOptions = {
        id: "account",
        header: "Account",
        icon: "dripicons-home",
        to: "/profile",
        children: [
            {
                label: "My Profile",
                to: "/profile",
            },
            {
                label: "Admin",
                link: "/admin",
                conditional: this.hasAdminAccess,
            },
            {
                label: "Admin",
                link: "/quiltyAdmin",
                conditional: this.hasThirdpartyAdminAccess,
            },
            {
                label: "Associated Organization",
                to: `${this.organizationLink}`,
                conditional: !!this.organizationLink,
            },
            {
                label: "Sign Out",
                action: this.signout,
            },
        ],
    };

    readonly calendarMenu: menuOptions = {
        id: "globalEvents",
        header: "Global Events",
        icon: "dripicons-calendar",
        to: "/conferences",
    };

    readonly launchpadMenu: menuOptions = {
        id: "gse",
        header: "Global Space Exchange",
        image: "/images/favicon.png",
        to: "/member",
        children: [
            {
                label: "Launchpad",
                to: "/member",
            },
            {
                label: "Explorer Tool",
                to: "/explorer-tool",
            },
            {
                label: "Industry Analytics",
                to: "/industry-analytics",
                // conditional: isAdmin(this.authStore.user),
                needsSubscription: !hasEnterpriseSubscription(this.authStore.user),
                needsSubscriptionFunc: this.needsEnterpriseSubscription,
            },
        ],
    };

    readonly quiltyMenu: menuOptions = {
        id: "quiltyInsights",
        header: "Quilty Insights",
        image: "/images/QS_Logo_Black_and_Blue_on_Transparent.svg",
        to: "/quiltyDashboard",
        children: [
            {
                label: "Dashboard",
                to: "/quiltyDashboard",
            },
            {
                label: "Reports",
                to: "/sector-company-reports",
            },
            {
                label: "Quilty QuickTakes",
                to: "/quilty-quicktakes",
            },
            // {
            //     label: "Quilty Insights",
            //     to: "/quilty-insights",
            // },
            {
                label: "Deals",
                to: "/deals",
            },
        ],
    };

    // menuOptions: menuOptions[] = [this.calendarMenu, this.launchpadMenu, this.quiltyMenu];

    get menuOptions(): menuOptions[] {
        let options = [this.calendarMenu];

        if (isQuiltySubscribed(this.authStore.user) && !isSubscribed(this.authStore.user)) {
            return [...options, this.quiltyMenu, this.launchpadMenu];
        } else {
            return [...options, this.launchpadMenu, this.quiltyMenu];
        }
    }

    get organizationLink(): string | null {
        return this.authStore.user?.organization
            ? `/organizations/${this.authStore.user?.organization.organizationid}`
            : null;
    }

    get hasAdminAccess(): boolean {
        return isAdmin(this.authStore.user);
    }

    get hasThirdpartyAdminAccess(): boolean {
        return isThirdpartyAdmin(this.authStore.user);
    }

    async signout() {
        await this.authStore.signout();
        window.location.href = "/";
    }

    needsSubscription() {
        this.modalStore.open();
    }

    needsEnterpriseSubscription() {
        this.subscriptionQuoteModalStore.open();
    }

    toggleSidebar() {
        let appendix = document.getElementById("appendix");
        if (appendix) {
            if (appendix.style.display !== "none") {
                appendix.style.display = "none";
                this.isSidebarOpen = false;
            } else {
                appendix.style.display = "flex";
                this.isSidebarOpen = true;
            }
        }
    }

    ensureSidebarIsOpen() {
        if (!this.isSidebarOpen) {
            this.toggleSidebar();
        }
    }

    get isOrganizationsView() {
        return this.$route.name === "organizations";
    }

    get isDealsView() {
        return this.$route.name === "deals";
    }

    disableSidebar() {
        return this.isOrganizationsView || this.isDealsView;
    }
}
